export const ACTIONS = {
  ADD_CONTACT: "add_contact",
  DELETE_CONTACT: "delete_contact",
  EDIT_CONTACT: "edit_contact",
};
export const MOODS = {
  ADD: "add",
  EDIT: "edit",
};
